module.exports = __webpack_public_path__ + "img/legend_point_01.dc7feefe.png";